


export interface OltagTypeItem{
    point?:any,
    subpoints?:any[],
    oltagsubtype?:'1' | 'a' | 'A' | 'i' | 'I';
} 

export interface TermsConditionsConstantsItems {
    h2tag?:string,
    ptag?:any[],
    oltagtype?:boolean;
    oltag?:OltagTypeItem[]
}



export const TermsConditionsList: TermsConditionsConstantsItems[]=[
    {
        h2tag:'1. GENERAL',
        ptag:[`This Agreement is a contract between you and Turtlemint Mutual Funds Distributors Private
        Limited (Turtlemint Money) and applies to your use of the Turtlemint Money Services (the
        "Services").
        <br />
        By registering for the Services, you must read, agree with and
        accept all of the terms and conditions contained in this
        Agreement. You agree that any use by you of the Services shall
        constitute your acceptance of the Agreement and we recommend
        that you store or print-off a copy of the Agreement (including
        all policies) for your records. This document is an electronic
        record in terms of Information Technology Act, 2000 and rules
        there under as applicable and the amended provisions pertaining
        to electronic records in various statutes as amended by the
        Information Technology Act, 2000.`,
        `This document is published in accordance with the provisions of
        The Information Technology (Intermediary Guidelines and Digital Media Ethics Code) 2021 that require publishing 
        the rules and regulations, privacy policy and Terms of Use for access or usage of
        www.Turtlemint Money.com website.`,
        `Please read this Agreement carefully and make sure that you
        understand it fully before using the Services.`] 
    },
    {
        h2tag:`2. ELIGIBILITY`,
        ptag:[`Use of the Website is available only to persons who can form
        legally binding contracts under Indian Contract Act, 1872.
        Persons who are &quot;incompetent to contract&quot; within the
        meaning of the Indian Contract Act, 1872 including minors,
        un-discharged insolvents etc. are not eligible to use the
        Website. If you are a minor i.e. under the age of 18 years, you
        shall not register as a User of the Turtlemint Money website and
        shall not transact on or use the website. As a minor if you wish
        to use or transact on website, such use or transaction may be
        made by your legal guardian or parents on the Website.
        Turtlemint Money serves the right to terminate your membership
        and / or refuse to provide you with access to the Website if it
        is brought to Turtlemint Money's notice or if it is discovered
        that you are under the age of 18 years.`
        ]
    },
    {
        h2tag:`3. PRIVACY AND AUTHORISATION`,
        ptag:[`You unconditionally accept, without limitation or qualification, the Terms of Use as set forth
        herein along with the terms and conditions as stated in our 
        <a href="privacy-policy">Privacy Policy</a> and provide consent to use and process
        your personal information as per the applicable laws.
        <br />`,
        `&nbsp;&nbsp;&nbsp;&nbsp; You hereby authorize Us and third-party provider(s) to: 
        <br />`,
        `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; a) use Your personal information.
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; b) exchange personal information with any individual or organization, including
        investigation agencies, Authorities, government administrators, other organizations,
        or service providers when relevant for the Services mentioned above.
        <br />`,
        `&nbsp;&nbsp;&nbsp;&nbsp; You understand that personal information may be subject to disclosure to those
        authorized under applicable law.`,
        `&nbsp;&nbsp;&nbsp;&nbsp; You agree that a photocopy or electronic version of this authorization shall be as valid
        as the original and may remain in effect for the continuous administration of the
        Services avail by you.`,
        `&nbsp;&nbsp;&nbsp;&nbsp; If You disclose to us any Personal Information relating to other people, you represent
        that You have the authority to do so and permit us to use the information for the
        purpose and service(s) as set out above. 
        `]
    },
    {
        h2tag:`4. REGISTRATION`,
        ptag: [`To use Turtlemint Money Services and access
        certain portions of the Website, you will need
        to register and obtain an account, username and
        password. When you register, the information you
        provide to us during the registration process
        will help us in offering content, service, and
        management of your account. You are solely
        responsible for maintaining the confidentiality
        of your account, username, and password and for
        all activities associated with or occurring
        under your Account. You represent and warrant
        that your Account information will be accurate
        at all times.`,
        `You agree that if You provide any information
        that is untrue, inaccurate, not current or
        incomplete or We have reasonable grounds to
        suspect that such information is untrue,
        inaccurate, not current or incomplete, or not in
        accordance with the this Terms of Use, We shall
        have the right to indefinitely suspend or
        terminate or block access of your membership on
        the Website and refuse to provide You with
        access to the Website.`,
        `You must notify us (a) immediately of any
        unauthorized use of your account and any other
        breach of security, and (b) ensure that you exit
        from your account at the end of each use of the
        Offerings. We cannot and will not be responsible
        for any loss or damage arising from your failure
        to comply with the foregoing requirements or as
        a result of use of your account, either with or
        without your knowledge, prior to your notifying
        us of unauthorized access to your account. You
        may not transfer your account to any other
        person and you may not use anyone else's account
        at any time without the permission of the
        account holder.`
        ],

    },
    {
        h2tag:`5. COMMUNICATIONS`,
        ptag:[`When You use the Website or send emails or other
        data, information or communication to us, You
        agree and understand that You are communicating
        with Us through electronic records and You
        consent to receive communications via electronic
        records from Us periodically and as and when
        required. We may communicate with you by email
        or by such other mode of communication,
        electronic or otherwise.`]
    },
    {
        h2tag:`6. TRANSACTION AND COMMUNICATION PLATFORM`,
        oltagtype:true,
        oltag:[
            {point:`The Website is a platform that Users utilize to meet and interact with third party for
            their transactions.`},
            {point:`Turtlemint Money is not and cannot be a
            party to or control in any manner any
            transaction between the Website's Users.`},
            {point:`All commercial/contractual terms are offered
            by and agreed to between Customers and
            third party alone.`},
            {point:`Turtlemint Money does not have any control
            or does not determine or advise or in any
            way involve itself in the offering or
            acceptance of such commercial/contractual
            terms between the Customers and third party.`},
            {point:`Turtlemint Money is not responsible for any
            non-performance or breach of any contract
            entered into between Customers and Vendors.
            Turtlemint Money cannot and does not
            guarantee that the concerned Customers and
            Vendors will perform any transaction
            concluded on the Website.`},
            {point:`Turtlemint Money shall not and is not
            required to mediate or resolve any dispute
            or disagreement between Customers and
            Vendors.`},
            {point:`Turtlemint Money does not make any
            representation or warranty as to the
            item-specifics (such as legal title,
            creditworthiness, identity, etc) of any of
            its Users. You are advised to independently
            verify the bona fides of any particular User
            that You choose to deal with on the Website
            and use Your best judgment in that behalf.`},
            {point:`Turtlemint Money does not at any point of
            time during any transaction between Customer
            and Vendors on the Website come into or take
            possession of any of the products or
            services offered by Seller nor does it at
            any point gain title to or have any rights
            or claims over the products or services
            offered by vendors to Customers.`},
            {point:`At no time shall Turtlemint Money hold any
            right, title or interest over the products
            nor shall Turtlemint Money have any
            obligations or liabilities in respect of
            such contract entered into between Customers
            and Vendors.`},
            {point:`You shall independently agree upon the
            manner and terms and conditions of delivery,
            payment, complaints etc. with the Vendors
            that You transact with.`},
            {point:`You release and indemnify Turtlemint Money
            and/or any of its officers and
            representatives from any cost, damage,
            liability or other consequence of any of the
            actions of the Users of the Website and
            specifically waive any claims that you may
            have in this behalf under any applicable
            law.`}
        ]
        
    },
    {
        h2tag:`7. INDEMNITY AND DISCLAIMER OF WARRANTY`,
        oltagtype:true,
        oltag:[
            {point:`You shall indemnify and hold harmless
            Turtlemint Money, its owner, licensee,
            affiliates, subsidiaries, group companies
            (as applicable) and their respective
            officers, directors, agents, and employees,
            from any claim or demand, or actions
            including reasonable attorneys' fees, made
            by any third party or penalty imposed due to
            or arising out of Your breach of this Terms
            of Use, privacy Policy and other Policies,
            or Your violation of any law, rules or
            regulations or the rights (including
            infringement of intellectual property
            rights) of a third party.`},

            {point:`The Website and all content and services
            provided on the Website are provided on an
            &quot;as is&quot; and &quot;as
            available&quot; basis. Turtlemint Money
            expressly disclaims all warranties of any
            kind, whether express or implied, including,
            but not limited to, the implied warranties
            of merchantability, fitness for a particular
            purpose, title, non-infringement, and
            security and accuracy, as well as all
            warranties arising by usage of trade, course
            of dealing, or course of performance.
            Turtlemint Money makes no warranty, and
            expressly disclaims any obligation, that:`,
            oltagsubtype:'i',
            subpoints:[`the content will be up-to-date,
            complete, comprehensive, accurate or
            applicable to your circumstances;`,
            `The Website will meet your
            requirements or will be available on
            an uninterrupted, timely, secure, or
            error-free basis;`,
            `the results that may be obtained
            from the use of the Website or any
            services offered through the website
            will be accurate or reliable`,
            `the quality of any products,
            services, information, or other
            material obtained by you through the
            website will meet your expectations.`]},

        ]
    },
    {
        h2tag:`8.INTELLECTUAL PROPERTY RIGHTS`,
        oltagtype:true,
        oltag:[
            {point:`This site is controlled and operated by
            Turtlemint Money and products are sold by
            respective third party. All material on this
            site, including images, illustrations, audio
            clips, and video clips, are protected by
            copyrights, trademarks, and other
            intellectual property rights.`},
            {point:`Material on Website is solely for Your
            personal, non-commercial use. You must not
            copy, reproduce, republish, upload, post,
            transmit or distribute such material in any
            way, including by email or other electronic
            means and whether directly or indirectly and
            You must not assist any other person to do
            so.`},
            {point:`Without the prior written consent of the
            owner, modification of the materials, use of
            the materials on any other website or
            networked computer environment or use of the
            materials for any purpose other than
            personal, non-commercial use is a violation
            of the copyrights, trademarks and other
            proprietary rights, and is prohibited. Any
            use for which You receive any remuneration,
            whether in money or otherwise, is a
            commercial use for the purposes of this
            clause.`}
        ]
    },
    {
        h2tag:`9. INTELLECTUAL PROPERTY AND TRADEMARK
        INFRINGEMENT COMPLAINTS`,
        ptag:[`Turtlemint Money respects the intellectual
        property of others. In case You feel that Your
        Trademark or Intellectual Property Rights have
        been infringed, You can write to us at <a href="mailto:help@turtlemintmoney.com">
        help@turtlemintmoney.com
        </a>`]
    },
    {
        h2tag:`10. DESCRIPTION`,
        ptag:[`Turtlemint Money does not warrant that Product
        and / or Services description or other content
        of this Website is accurate, complete, reliable,
        current, or error-free and assumes no liability
        in this regard.`]
    },
    {
        h2tag:`11. LIMITATION OF LIABILITY`,
        oltagtype:true,
        oltag:[
            {
                point:`In no event shall turtlemint money be liable for any special, incidental, indirect or
                consequential damages of any kind in connection with these terms of use, even if
                user has been informed in advance of the possibility of such damages.`
            },
            {point:`Turtlemint Money (including its officers,
                directors, employees, representatives,
                affiliates, and providers) will not be
                responsible or liable for`,
                oltagsubtype:`i`,
                subpoints:[`any injury, death, loss, claim, act
                of god, accident, delay, or any
                direct, special, exemplary,
                punitive, indirect, incidental or
                consequential damages of any kind
                (including without limitation lost
                profits or lost savings), whether
                based in contract, tort, strict
                liability or otherwise, that arise
                out of or is in any way connected
                with 
                <ol type="1"> <li>
                any failure or delay
                (including without
                limitation the use of or
                inability to use any
                component of the Website),
                or </li>
                <li>any use of the Website or content,</li>
                <li>the performance or non-performance by us or any provider, even if we have been advised of the possibility of damages to such parties or any other party,
                </li>
                </ol>`
                ,
                `or, any damages to or viruses
                that may infect your computer
                equipment or other property as
                the result of your access to the
                Website or your downloading of
                any content from the Website.`
                ,
                `The website may provide links to
                other third party websites.
                However since Turtlemint Money
                has no control over such third
                party websites, you acknowledge
                and agree that Turtlemint Money
                is not responsible for the
                availability of such third party
                websites, and does not endorse
                and is not responsible or liable
                for any content, advertising,
                products or other materials on
                or available from such third
                party websites. You further
                acknowledge and agree that
                Turtlemint Money shall not be
                responsible or liable, directly
                or indirectly, for any damage or
                loss caused or alleged to be
                caused by or in connection with
                use of or reliance on any such
                content, goods or services
                available on or through any such
                third party websites.`]
            },
            { point : `In no event will Turtlemint Money’s aggregate liability arising out of or in connection with
            these Terms of Use and your use of the Website, Application and Services , exceed the
            amounts agreeable to Turtlemint Money.`}
        ]
    },
    {
        h2tag:`12. DISCLAIMER`,
        oltagtype:true,
        oltag:[
            {point:`The User acknowledges and confirms that
            he/she is well aware of the rules &amp;
            regulations and the risks involved in
            services offered by Turtlemint Money.
            Changes are periodically added to the
            information herein.`},
            {point:`Turtlemint Money may make improvements
            and/or changes on this web site at any time.
            We will not be responsible for any data
            accessed / mis-utilized by unauthorized use
            of Turtlemint Money website by third party
            due to user's neglect or due to allowing
            access to personal data to third party
            intentionally or unintentionally.`},
            {point:`Turtlemint Money will not be involved in any
            financial handling. The user hereby agrees
            not to raise any claim or dispute against
            Turtlemint Money and its directors,
            officers, employees or agents against any
            breach of law which is done by user or money
            changers which is beyond the control of
            Turtlemint Money.`},
            {
                point:`No legal right is there to any member or
                user of Turtlemint Money to raise dispute
                against Turtlemint Money. Turtlemint Money
                shall have the absolute discretion to amend
                or supplement any of the Terms at any time.
                We may communicate the amended terms by
                hosting the same on the Website or in any
                other manner as decided by Turtlemint Money.
                The user shall be responsible for regularly
                reviewing these terms including amendments
                thereto as may be posted on the Website.`
            },
        ]
    },
    {
        h2tag:`13. LINKS TO OTHER SITES`,
        ptag : [`Our Website links to other websites that may
        collect personally identifiable information
        about you. Turtlemint Money is not responsible
        for the privacy practices or the content of
        those linked websites.`,
        ]
    },
    {  
        h2tag:`14. APPLICABLE LAW AND JURISDICTION`,
        ptag:[`These Terms of Use shall be governed by and
        interpreted and construed in accordance with the
        laws of India. The place of jurisdiction shall
        be exclusively in Mumbai.`,
        `Any dispute, claim or controversy arising out of or relating to this Terms including the
        determination of the scope or applicability of this Terms to arbitrate, or your use of the
        Application or information to which it gives access, shall be determined by arbitration in India,
        before a sole arbitrator mutually appointed by the disputed Customer and Turtlemint Money.
        Arbitration shall be conducted in accordance with the Arbitration and Conciliation Act, 1996.
        The seat of such arbitration shall be Mumbai. All proceedings of such arbitration, including,
        without limitation, any awards, shall be in the English language. The award shall be final and
        binding on the parties to the dispute.`
    ]
    },
    {  
        h2tag:`15. INDIA ONLY`,
        ptag:[`Unless otherwise specified, the material on the
        Website is presented solely for the purpose of
        sale in India. Turtlemint Money make no
        representation that materials in the Website are
        appropriate or available for use in other
        locations/Countries other than India. Those who
        choose to access this site from other
        locations/Countries other than India do so on
        their own initiative and Turtlemint Money is not
        responsible for services or supply of
        products/refund for the products ordered from
        other locations/Countries other than India,
        compliance with local laws, if and to the extent
        local laws are applicable.`]
    },
    {  
        h2tag:`16. TERMINATION`,
        ptag:[`This Agreement is effective upon Your acceptance as set forth herein and shall continue in
        full force until terminated Turtlemint Money reserves the right, in its sole discretion and without
        notice, at any time and for any reason, to:`],
        oltagtype: true,
        oltag: [
            {point: `remove or disable access to all or any portion of
            the Service;`},
            {point: `suspend Your access to or use of all or any portion of the Service; and`},
            {point:`terminate this Agreement.`}
        ]
    },
    {  
        h2tag:`17. ENTIRE AGREEMENT`,
        ptag:[`Except as they may be supplemented by additional Turtlemint Money policies, guidelines,
        standards, or terms for a specific product, feature, service constitute the entire and exclusive
        understanding and agreement between Turtlemint Money and You regarding the Platform or
        its services and the applicable Terms supersede and replace any and all prior oral or written
        understandings or agreements between Turtlemint Money and You.`]
    },
    {  
        h2tag:`18. NOTICES`,
        ptag:[`Any notices or other communications permitted or required hereunder, including those
        regarding modifications to these Terms of Use, will be in writing and given by Turtlemint Money`],
        oltagtype: true,
        oltag: [
            {point: ` via email (in each case to the address that You provide) or`},
            {point: `by posting to the Site or via
            the Application. For notices made by e-mail, the date of receipt will be deemed the date on
            which such notice is transmitted.`}
        ]
    },
    {
        h2tag:`19. WEBSITE USE`,
        ptag:[`You agree, undertake and confirm that Your use
        of Website shall be strictly governed by the
        following binding principles:`],
        oltagtype:true,
        oltag:[
            {
                point:`You shall not host, display, upload, modify,
                publish, transmit, update or share any
                information which:`,
                oltagsubtype:`1`,
                subpoints:[`belongs to another person and to
                which You does not have any right
                to.`,
                `is obscene, pornographic, paedophilic, invasive of another’s privacy including
                bodily privacy, insulting or harassing on the basis of gender, racially or
                ethnically objectionable, relating or encouraging money laundering or
                gambling or promoting enmity between different groups on the grounds of
                religion or caste with the intent to incite violence;`,

                `is harmful to child; `,
            
                `infringes any patent, trademark, copyright or other proprietary rights;`,
                
                `deceives or misleads the addressee about the origin of the message or
                knowingly and intentionally communicates any misinformation or
                information which is patently false and untrue or misleading in nature`,
            
                `impersonates another person;`,
                `threatens the unity, integrity, defence, security or sovereignty of India,
                friendly relations with foreign States, or public order, or causes incitement
                to the commission of any cognisable offence, or prevents investigation of
                any offence, or is insulting other nation; `,
                `contains software virus or any other computer code, file or program
                designed to interrupt, destroy or limit the functionality of any computer
                resource;`,
                `violates any law for the time being in force;`,
                `is grossly harmful, harassing, blasphemous, defamatory, obscene,
                pornographic, paedophilic, libellous, invasive of another's privacy, hateful, or
                racially, ethnically objectionable, disparaging, relating or encouraging money
                laundering or gambling, or otherwise unlawful in any manner whatever; or,`,
                `unlawfully threatening or unlawfully
                harassing including but not limited
                to &quot;indecent representation of
                women&quot; within the meaning of
                the Indecent Representation of Women
                (Prohibition) Act, 1986;`,
                `is misleading in any way;`,
                `is patently offensive to the online
                community, such as sexually explicit
                content, or content that promotes
                obscenity, paedophilia, racism,
                bigotry, hatred or physical harm of
                any kind against any group or
                individual;`,
                `Harasses or advocates harassment of
                another person;`,
                `Involves the transmission of
                &quot;junk mail&quot;, &quot;chain
                letters&quot;, or unsolicited mass
                mailing or &quot;spamming&quot;;`,
                `promotes illegal activities or
                conduct that is abusive,
                threatening, obscene, defamatory or
                libellous;`,
                `infringes upon or violates any third
                party's rights [including, but not
                limited to, intellectual property
                rights, rights of privacy (including
                without limitation unauthorized
                disclosure of a person's name, email
                address, physical address or phone
                number) or rights of publicity];`,
                `promotes an illegal or unauthorized
                copy of another person's copyrighted
                work (see &quot;Copyright
                complaint&quot; below for
                instructions on how to lodge a
                complaint about uploaded copyrighted
                material), such as providing pirated
                computer programs or links to them,
                providing information to circumvent
                manufacture-installed copy-protect
                devices, or providing pirated music
                or links to pirated music files;`,
                `Contains restricted or password-only
                access pages, or hidden pages or
                images (those not linked to or from
                another accessible page);`,
                `Provides material that exploits
                people in a sexual, violent or
                otherwise inappropriate manner or
                solicits personal information from
                anyone;`,
                `Provides instructional information
                about illegal activities such as
                making or buying illegal weapons,
                violating someone's privacy, or
                providing or creating computer
                viruses; contains video, photographs,
                or images of another person (with a
                minor or an adult).`,
                `tries to gain unauthorized access or
                exceeds the scope of authorized
                access to the Website or to
                profiles, blogs, communities,
                account information, bulletins,
                friend request, or other areas of
                the Website or solicits passwords or
                personal identifying information for
                commercial or unlawful purposes from
                other users.`,
                `engages in commercial activities
                and/or sales without Our prior
                written consent such as contests,
                sweepstakes, barter, advertising and
                pyramid schemes, or the buying or
                selling of &quot;virtual&quot;
                products related to the Website.
                Throughout this Terms of Use,
                Turtlemint Money's prior written
                consent means a communication coming
                from Turtlemint Money's Legal
                Department, specifically in response
                to Your request, and specifically
                addressing the activity or conduct
                for which You seek authorization;`,
                `Solicits gambling or engages in any
                gambling activity which We, in Our
                sole discretion, believes is or
                could be construed as being illegal;`,
                `Interferes with another USER's use
                and enjoyment of the Website or any
                other individual's User and
                enjoyment of similar services;`,
                `Refers to any website or URL that,
                in Our sole discretion, contains
                material that is inappropriate for
                the Website or any other website,
                contains content that would be
                prohibited or violates the letter or
                spirit of these Terms of Use.`,
                `contains software viruses or any
                other computer code, files or
                programs designed to interrupt,
                destroy or limit the functionality
                of any computer resource; or,`,
                `contains any trojan horses, worms,
                time bombs, cancel bots, easter eggs
                or other computer programming
                routines that may damage,
                detrimentally interfere with,
                diminish value of, surreptitiously
                intercept or expropriate any system,
                data or personal information;`,
                `Threatens the unity, integrity,
                defence, security or sovereignty of
                India, friendly relations with
                foreign states, or public order or
                causes incitement to the commission
                of any cognizable offence or
                prevents investigation of any
                offence or is insulting any other
                nation.`,
                `Shall not be false, inaccurate or
                misleading;`,
                `shall not, directly or indirectly,
                offer, attempt to offer, trade or
                attempt to trade in any item, the
                dealing of which is prohibited or
                restricted in any manner under the
                provisions of any applicable law,
                rule, regulation or guideline for
                the time being in force.`,
                `shall not create liability for Us or
                cause Us to lose (in whole or in
                part) the services of Our internet
                service provider (&quot;ISPs&quot;)
                or other suppliers;`,
                ]
            },
            {
                point:`You shall not use any &quot;deep-link&quot;,
                &quot;page-scrape&quot;, &quot;robot&quot;,
                &quot;spider&quot; or other automatic
                device, program, algorithm or methodology,
                or any similar or equivalent manual process,
                to access, acquire, copy or monitor any
                portion of the Website or any Content, or in
                any way reproduce or circumvent the
                navigational structure or presentation of
                the Website or any Content, to obtain or
                attempt to obtain any materials, documents
                or information through any means not
                purposely made available through the
                Website. We reserve Our right to bar any
                such activity.`
            },
            {
                point:`You shall not attempt to gain unauthorized
                access to any portion or feature of the
                Website, or any other systems or networks
                connected to the Website or to any server,
                computer, network, or to any of the services
                offered on or through the Website, by
                hacking, password &quot;mining&quot; or any
                other illegitimate means.`
            },
            {
                point:`You shall not probe, scan or test the
                vulnerability of the Website or any network
                connected to the Website nor breach the
                security or authentication measures on the
                Website or any network connected to the
                Website. You may not reverse look-up, trace
                or seek to trace any information on any
                other User of or visitor to Website, or any
                other customer, including any account on the
                Website not owned by You, to its source, or
                exploit the Website or any service or
                information made available or offered by or
                through the Website, in any way where the
                purpose is to reveal any information,
                including but not limited to personal
                identification or information, other than
                Your own information, as provided for by the
                Website.`
            },
            {
                point:`You shall not make any negative, denigrating
                or defamatory statement(s) or comment(s)
                about Us or the brand name or domain name
                used by Us including the terms Turtlemint
                Money, or otherwise engage in any conduct or
                action that might tarnish the image or
                reputation, of Turtlemint Money or Vendors
                on platform or otherwise tarnish or dilute
                any Turtlemint Money 's trade or service
                marks, trade name and/or goodwill associated
                with such trade or service marks, trade name
                as may be owned or used by us. You agree
                that You will not take any action that
                imposes an unreasonable or
                disproportionately large load on the
                infrastructure of the Website or Turtlemint
                Money 's systems or networks, or any systems
                or networks connected to Turtlemint Money.`
            },
            {
                point:`You agree not to use any device, software or
                routine to interfere or attempt to interfere
                with the proper working of the Website or
                any transaction being conducted on the
                Website, or with any other person's use of
                the Website.`
            },
            {
                point:`You may not forge headers or otherwise
                manipulate identifiers in order to disguise
                the origin of any message or transmittal You
                send to Us on or through the Website or any
                service offered on or through the Website.
                You may not pretend that You are, or that
                You represent, someone else, or impersonate
                any other individual or entity.`
            },
            {
                point:`You may not use the Website or any content
                for any purpose that is unlawful or
                prohibited by these Terms of Use, or to
                solicit the performance of any illegal
                activity or other activity which infringes
                the rights of Turtlemint Money and / or
                others.`
            },
            {
                point:`You shall at all times ensure full
                compliance with the applicable provisions of
                the Information Technology Act, 2000 and
                rules there under as applicable and as
                amended from time to time and also all
                applicable Domestic laws, rules and
                regulations and International Laws, Business
                Laws, Statutes, Ordinances and Regulations
                (including, but not limited to Sales
                Tax/VAT, Income Tax, Octroi, Service Tax,
                Central Excise, Custom Duty, Local Levies)
                regarding Your use of Our service and Your
                listing, purchase, solicitation of offers to
                purchase, and sale of products or services.
                You shall not engage in any transaction in
                an item or service, which is prohibited by
                the provisions of any applicable law s or
                regulations for the time being in force.`
            },
            {
                point:`Solely to enable Us to use the information
                You supply Us with, so that we are not
                violating any rights You might have in Your
                Information, You agree to grant Us a
                non-exclusive, worldwide, perpetual,
                irrevocable, royalty-free, sub-licensable
                (through multiple tiers) right to exercise
                the copyright, publicity, database rights or
                any other rights You have in Your
                Information, in any media now known or not
                currently known, with respect to Your
                Information. We will only use Your
                information in accordance with the Terms of
                Use and Privacy Policy applicable to use of
                the Website. You shall not engage in
                advertising to, or solicitation of, other
                Users of the Website to buy or sell any
                products or services, including, but not
                limited to, products or services related to
                that being displayed on the Website or
                related to us. You may not transmit any
                chain letters or unsolicited commercial or
                junk email to other Users via the Website.
                It shall be a violation of these Terms of
                Use to use any information obtained from the
                Website in order to harass, abuse, or harm
                another person, or in order to contact,
                advertise to, solicit, or sell to another
                person other than Us without Our prior
                explicit consent. In order to protect Our
                Users from such advertising or solicitation,
                We reserve the right to restrict the number
                of messages or emails which a user may send
                to other Users in any 24-hour period which
                We deems appropriate in its sole discretion.
                You understand that We have the right at all
                times to disclose any information (including
                the identity of the persons providing
                information or materials on the Website) as
                necessary to satisfy any law, regulation or
                valid governmental request. This may
                include, without limitation, disclosure of
                the information in connection with
                investigation of alleged illegal activity or
                solicitation of illegal activity or in
                response to a lawful court order or
                subpoena. In addition, We can (and You
                hereby expressly authorize Us to) disclose
                any information about You to law enforcement
                or other government officials, as we, in Our
                sole discretion, believe necessary or
                appropriate in connection with the
                investigation and/or resolution of possible
                crimes, especially those that may involve
                personal injury. We reserve the right, but
                has no obligation, to monitor the materials
                posted on the Website. Turtlemint Money
                shall have the right to remove or edit any
                content that in its sole discretion
                violates, or is alleged to violate, any
                applicable law or either the spirit or
                letter of these Terms of Use.
                Notwithstanding this right, YOU REMAIN
                SOLELY RESPONSIBLE FOR THE CONTENT OF THE
                MATERIALS YOU POST ON THE WEBSITE AND IN
                YOUR PRIVATE MESSAGES. Please be advised
                that such Content posted does not
                necessarily reflect Turtlemint Money views.
                In no event shall Turtlemint Money assume or
                have any responsibility or liability for any
                Content posted or for any claims, damages or
                losses resulting from use of Content and/or
                appearance of Content on the Website. You
                hereby represent and warrant that You have
                all necessary rights in and to all Content
                which You provide and all information it
                contains and that such Content shall not
                infringe any proprietary or other rights of
                third parties or contain any libellous,
                tortious, or otherwise unlawful information.`
            },
            {
                point:`Your correspondence or business dealings
                with, or participation in promotions of,
                advertisers found on or through the Website,
                including payment and delivery of related
                products or services, and any other terms,
                conditions, warranties or representations
                associated with such dealings, are solely
                between You and such advertiser. We shall
                not be responsible or liable for any loss or
                damage of any sort incurred as the result of
                any such dealings or as the result of the
                presence of such advertisers on the Website.`
            },


        ]
    }
]